/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import {} from '@oneaudi/unified-web-alpha-common';
import { StyledTile, StyledDisabledWrap } from './index.styles.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
export const hasHref = (props) => {
    return typeof props.href === 'string';
};
export const Tile = forwardRef((props, ref) => {
    const { margin, className, children, selected } = props;
    const baseProps = {
        selected,
        margin,
        className,
        ...pickA11yProps(props),
        ...pickDataProps(props),
        ref
    };
    if (hasHref(props)) {
        const { onClick, target, rel, href } = props;
        return (React.createElement(StyledTile, { as: "a", ...baseProps, href: href, rel: rel, target: target, onClick: onClick }, children));
    }
    const { disabled, type = 'button', onClick } = props;
    return (React.createElement(StyledTile, { as: "button", "aria-disabled": disabled, ...baseProps, disabled: disabled, onClick: onClick, type: type }, disabled ? (React.createElement(StyledDisabledWrap, null, children)) : (children)));
});
Tile.displayName = 'Tile';
//# sourceMappingURL=index.js.map